import { RouteObject } from "react-router-dom";
import GLEntityDashboard from "./components/landing/landing";
export interface GlRouteRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: GlRouteRoute[];
}
export const bxGlRouteRoute: GlRouteRoute[] = [
  {
    path: "/bx/gl-code",
    element: <GLEntityDashboard />,
  },
];
